<template>
  <div class="page-box">
    <Header />
    <AiMarketingContent />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import AiMarketingContent from './AiMarketingContent.vue'
export default {
  name: "Market",
  components: {
    Header,
    Footer,
    AiMarketingContent
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
